import { render, staticRenderFns } from "./WfCorpVehicleForm.vue?vue&type=template&id=2227de12&"
import script from "./WfCorpVehicleForm.vue?vue&type=script&lang=js&"
export * from "./WfCorpVehicleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports